import React, { useEffect, useRef, useState } from "react";
import Cropper from "cropperjs";
import "./ImageCropper.css";

const ImageCropper = ({ image, onCropComplete, ratio }) => {
  const cropperRef = useRef(null);
  const imageElement = useRef(null);
  const [showeditor, setShoweditor] = useState(false);
  useEffect(() => {
    if (imageElement.current) {
      const cropper = new Cropper(imageElement.current);
      cropperRef.current = cropper;

      const selection = cropper.getCropperSelection();
      const cropperImage = cropper.getCropperImage();
      const canvas = cropper.getCropperCanvas();

      if (selection) {
        selection.aspectRatio = ratio ? ratio : 1;
        selection.zoomable = false;
        // Same effect as v1's autoCrop + setCropBoxData(full image): the
        // initial selection covers 100% of the image on first render.
        selection.initialCoverage = 1;
      }
      if (cropperImage) {
        cropperImage.scalable = false;
        cropperImage.rotatable = false;
      }

      // v1's `cropend` option doesn't exist in v2; `actionend` on the canvas
      // fires whenever the user finishes moving/resizing the selection,
      // which is the only action still possible with scale/rotate/zoom off.
      canvas?.addEventListener("actionend", handleCropComplete);

      return () => {
        canvas?.removeEventListener("actionend", handleCropComplete);
        cropper.destroy();
      };
    }
  }, [image, showeditor]);

  const handleCropComplete = () => {
    if (cropperRef.current) {
      cropperRef.current
        .getCropperSelection()
        .$toCanvas()
        .then((croppedCanvas) => {
          const mimeType = image.match(/data:(.*?);base64,/)[1];
          if (mimeType === "image/png") {
            const base64 = croppedCanvas.toDataURL("image/png");
            const file = dataURLToFile(base64, "cropped-image.png");
            const fileSizeInMB = file.size / (1024 * 1024);

            onCropComplete(base64, file);
          } else if (mimeType === "image/jpeg" || mimeType === "image/jpg") {
            const base64 = croppedCanvas.toDataURL("image/jpeg");
            const file = dataURLToFile(base64, "cropped-image.jpg");
            const fileSizeInMB = file.size / (1024 * 1024);

            onCropComplete(base64, file);
          } else {
            console.error("Unsupported image type:", mimeType);
          }
        });
    }
  };

  const dataURLToFile = (dataUrl, filename) => {
    const arr = dataUrl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  };

  return (
    <div className="editor-container">
      <div className="Editor-name">
        <div
          className="d-flex align-items-center justify-content-between header-image"
          onClick={() => {
            setShoweditor(!showeditor);
          }}
        >
          <p>Edit Image</p>
          <i
            className={showeditor ? "fa fa-chevron-up" : "fa fa-chevron-down"}
            style={{
              color: "#ffffff",
              transition: "all ease-in 0.3s",
            }}
          ></i>
        </div>
      </div>
      {showeditor && (
        <div className="cropper-viewport" style={{ width: "100%", height: "250px" }}>
          {image && (
            <img
              ref={imageElement}
              src={image}
              alt="Selected"
              style={{ maxWidth: "100%", height: "100%" }}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default ImageCropper;
